import React, { useState } from 'react';
import { CreditCard, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { createCheckout } from '../services/subscriptionApi';

const TrialExpired = () => {
  const { logout } = useAuth();
  const [loadingPlan, setLoadingPlan] = useState(null);

  const handleCheckout = async (interval) => {
    setLoadingPlan(interval);
    try {
      const res = await createCheckout(interval);
      window.location.href = res.data.url;
    } catch {
      setLoadingPlan(null);
    }
  };

  return (
    <div className="min-h-screen bg-dark-bg flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="bg-dark-surface border border-dark-border rounded-2xl p-8 space-y-6">
          <div className="w-16 h-16 rounded-full bg-carmin/10 border border-carmin/30 flex items-center justify-center mx-auto">
            <CreditCard className="h-8 w-8 text-carmin" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-primary mb-2">
              Votre essai gratuit est terminé
            </h1>
            <p className="text-secondary text-sm leading-relaxed">
              Pour continuer à utiliser Carmin, choisissez votre formule d'abonnement.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {/* Monthly plan */}
            <div className="bg-black/20 rounded-xl p-4 space-y-3 border border-dark-border">
              <div>
                <h3 className="text-primary font-semibold">Mensuel</h3>
                <p className="text-2xl font-bold text-primary mt-1">49€<span className="text-sm font-normal text-muted">/mois</span></p>
              </div>
              <button
                onClick={() => handleCheckout('month')}
                disabled={loadingPlan !== null}
                className="w-full px-4 py-2 bg-dark-border text-primary rounded-lg text-sm font-medium hover:bg-dark-border/80 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loadingPlan === 'month' ? 'Redirection...' : 'Choisir mensuel'}
              </button>
            </div>
            {/* Annual plan */}
            <div className="bg-black/20 rounded-xl p-4 space-y-3 border border-carmin/30 relative">
              <div className="absolute -top-2.5 left-1/2 -translate-x-1/2">
                <span className="bg-green-500/20 text-green-400 text-xs font-medium px-2 py-0.5 rounded-full border border-green-500/30">
                  Économisez 98€
                </span>
              </div>
              <div>
                <h3 className="text-primary font-semibold">Annuel</h3>
                <p className="text-2xl font-bold text-primary mt-1">490€<span className="text-sm font-normal text-muted">/an</span></p>
                <p className="text-xs text-muted mt-1">soit ~40,80€/mois</p>
              </div>
              <button
                onClick={() => handleCheckout('year')}
                disabled={loadingPlan !== null}
                className="w-full px-4 py-2 bg-carmin text-white rounded-lg text-sm font-medium hover:bg-carmin/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loadingPlan === 'year' ? 'Redirection...' : 'Choisir annuel (Recommandé)'}
              </button>
            </div>
          </div>
          <button
            onClick={logout}
            className="flex items-center gap-2 mx-auto px-4 py-2 rounded-lg text-secondary hover:text-primary transition-colors text-sm"
          >
            <LogOut className="h-4 w-4" />
            Se déconnecter
          </button>
        </div>
      </div>
    </div>
  );
};

export default TrialExpired;
